import { TaskStatusOptions } from 'modules/constants';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce';
// import { utils, writeFile } from 'xlsx'; // kept for rollback

import excelIcon from '../../assets/img/icons/excel-green.svg';
import plusIcon from '../../assets/img/icons/plus_white.svg';
import ProjectDropdown from '../../components/CommonFilter/ProjectDropdown';
import FilterDropDownStyle from '../../components/DropdownStyle/FilterDropDownStyle';
import ButtonTextLoader from '../../components/Loaders/ButtonTextLoader';
import BottomPagination from '../../components/Pagination/BottomPagination/BottomPagination';
import TopPagination from '../../components/Pagination/TopPagination/TopPagination';
import Select from '../../components/ReactSelectDropdown';
import {
  ButtonIcon,
  ColoredButton,
  ColoredButtonWithIcon,
  PrimaryButton,
  WhiteButton,
  WhiteButtonWithIcon,
} from '../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonText,
  FormAlert,
  HeaderContainer,
  PageTitle,
} from '../../styledComponents/common';
import { exportToExcel } from '../../utils/exportToExcel';
import { checkHtml, checkUrl } from '../../utils/helper';
import DeleteTaskModal from './DeleteTaskModal';
import TaskFilter from './TaskFilter';
import TasksList from './TasksList';
// import { defaultApi } from '../../utils/axiosApi'; // kept for rollback

const Tasks = ({
  selectedOrganization,
  getOrganizationMembersList,
  orgMembersList,
  loadingTaskAssigneeId,
  isLoading,
  officesShortList,
  getOfficesShortList,
  getTasksList,
  tasksList,
  deleteTask,
  deletedCallback,
  deleteIsLoading,
  createdTaskInfo,
  createTask,
  // pagination
  totalTasksCount,
  pageSize,
  history,
}) => {
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const statusFromParams = urlParams.get('status');
  const [zoneFromParams, setZoneFromParams] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const tmpZoneFromParams = urlParams.get('zone');
  if (statusFromParams || tmpZoneFromParams) {
    const newUrl = `${window.location.pathname}`;
    window.history.replaceState({}, '', newUrl);
  }
  useEffect(() => {
    tmpZoneFromParams && setZoneFromParams(tmpZoneFromParams);
  }, [tmpZoneFromParams]);

  const [selectedDate, setSelectedDate] = useState({
    startDate:
      statusFromParams || tmpZoneFromParams
        ? moment('2024-01-01')
        : moment(new Date()),
    endDate: moment(new Date()),
  });
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedMember, setSelectedMember] = useState('');
  const [taskStatus, setTaskStatus] = useState({
    label: t('all_status'),
    value: null,
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [search, setSearch] = useState(false);
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');
  const [expandedTaskId, setExpandedTaskId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [taskIdDelete, setTaskIdDelete] = useState(null);

  const [reportLoading, setReportLoading] = useState(false);
  const [allReportLoading, setAllReportLoading] = useState(false);

  // pagination
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  useEffect(() => {
    if (deletedCallback) {
      console.log(4);
      getTasksList({
        startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
      });
    }
  }, [deletedCallback]);

  useEffect(() => {
    if (createdTaskInfo) {
      console.log(3);
      getTasksList({
        startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
      });
    }
  }, [createdTaskInfo]);
  const handleSearchByName = () => {
    setCurrentSearchedTerm(searchTerm);
    setSearch(!search);
    setCurrentPageNumber(1);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setSearch(!search);
  };

  const handlePageChange = page => {
    setCurrentPageNumber(page);
  };

  const selectOffice = e => {
    setCurrentPageNumber(1);
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setSelectedOffice(e);
  };

  const selectMember = person => {
    setSelectedMember(person);
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPageNumber(1);
  };

  const clearMember = () => {
    setSelectedMember('');
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPageNumber(1);
  };

  const onSearchTermChange = e => {
    const { value } = e.target;
    if (value !== '') {
      setSelectedMember('');
    }
    setSearchTerm(value);
  };

  const handleStatusChange = e => {
    setTaskStatus(e);
    setCurrentPageNumber(1);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
    setCurrentPageNumber(1);
  };

  const toggleDeleteModal = taskId => {
    setIsOpen(!isOpen);
    if (taskId) {
      setTaskIdDelete(taskId);
    }
  };

  const handleDeleteTask = () => {
    if (taskIdDelete) {
      const payload = {
        task_id: taskIdDelete,
      };
      deleteTask(payload);
      toggleDeleteModal();
    }
  };

  const handleExportToExcel = async () => {
    if (selectedOffice && selectedOffice.value) {
      const url = `albait/export/task-report/?date=${moment(
        selectedDate,
      ).unix()}&office=${selectedOffice.value}`;

      setReportLoading(true);
      const response = await exportToExcel(url, null, true);
      setReportLoading(false);
    }
  };

  const handleSpecificOfficeExportToExcel = async () => {
    if (!selectedOffice?.value) {
      return;
    }

    try {
      setExportLoading(true);
      const payload = {
        startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
        office_id: selectedOffice.value,
      };

      if (selectedMember?.id) {
        payload.assignee_id = selectedMember.id;
      }
      if (searchTerm?.trim()) {
        payload.task_name = searchTerm.toLowerCase().trim();
      }
      if (taskStatus?.value && taskStatus.value !== 'all') {
        payload.status = taskStatus.value;
      }

      // Construct the API URL
      // const url = `tasks/export-tasks/?required_start_date=${payload.startDate}&required_end_date=${payload.endDate}${payload.task_name ? `&name=${payload.task_name}` : ''
      //   }${payload.office_id ? `&office_id=${payload.office_id}` : ''}${payload.assignee_id ? `&assignees=${payload.assignee_id}` : ''
      //   }${payload.status ? `&status=${payload.status}` : ''}`;

      const url = `albait/export/detailed-task-report/?date_from=${payload.startDate}&date_to=${payload.endDate}${payload.task_name ? `&name=${payload.task_name}` : ''
        }${payload.office_id ? `&office_id=${payload.office_id}` : ''}${payload.assignee_id ? `&assignees=${payload.assignee_id}` : ''
        }${payload.status ? `&status=${payload.status}` : ''}`;

      // ── NEW: API returns a ready-made XLSX binary, download it directly ──
      await exportToExcel(url, `Tasks_Report_${moment().format('YYYY-MM-DD')}.xlsx`, true);

      // ── OLD: called defaultApi (JSON), then manually built XLSX on frontend ──
      // const response = await defaultApi(url, 'GET', payload);
      // if (!response?.data) { throw new Error('No data received from the server'); }
      // const data = response.data;
      // if (!Array.isArray(data)) { console.warn('No tasks data available for export'); return; }
      // const excelData = data.map(task => {
      //   const assignee = task.assignees?.[0] || {};
      //   const assigneeName = assignee.first_name && assignee.last_name ? `${assignee.first_name} ${assignee.last_name}` : '-';
      //   const start = task.required_start_date ? moment(task.required_start_date).format('h:mm a') : '-';
      //   const end = task.required_end_date ? moment(task.required_end_date).format('h:mm a') : '-';
      //   let statusLabel = '-';
      //   switch (task.status) {
      //     case 'to do': statusLabel = 'To Do'; break;
      //     case 'complete': statusLabel = 'Completed'; break;
      //     case 'in progress': statusLabel = 'In Progress'; break;
      //     case 'partially complete': statusLabel = 'Partially Complete'; break;
      //     case 'not completed': statusLabel = 'Not Completed'; break;
      //     case 'missed':
      //     case 'totally missed': statusLabel = 'Missed'; break;
      //     default: statusLabel = task.status || '-';
      //   }
      //   let approvalLabel = '-';
      //   if (task.approval && (task.status === 'complete' || task.status === 'partially complete')) {
      //     approvalLabel = task.approval.charAt(0).toUpperCase() + task.approval.slice(1);
      //   }
      //   let checkOutReason = '-';
      //   if (task.checkinout?.length > 0) {
      //     const checkout = task.checkinout.find(e => e.event === 'checkout');
      //     if (checkout) {
      //       if (checkout.manual_tracking_off && checkout.check_out_reason === 'forced') { checkOutReason = 'Checkout due to location'; }
      //       else if (!checkout.manual_tracking_off && checkout.check_out_reason === 'forced') { checkOutReason = 'Checkout due to time'; }
      //       else if (checkout.check_out_reason === 'normal') { checkOutReason = 'Normal'; }
      //       else { checkOutReason = checkout.check_out_reason || '-'; }
      //     }
      //   }
      //   return {
      //     'Task Name': task.name || '-', 'Task code': task.task_code || '-', 'Office': task.office || '-',
      //     'Assignee': assigneeName, 'Start-End': `${start} - ${end}`, 'Status': statusLabel,
      //     'Approval': approvalLabel, 'Check Out Reason': checkOutReason,
      //   };
      // });
      // const ws = utils.json_to_sheet(excelData);
      // ws['!cols'] = [{ wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 20 }];
      // const wb = utils.book_new();
      // utils.book_append_sheet(wb, ws, 'Tasks Report');
      // writeFile(wb, `Tasks_Report_${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      console.error('Export Error:', error);
      // You might want to show an error message to the user here
    } finally {
      setExportLoading(false);
    }
  };

  const handleExportAllOfficesReportToExcel = useDebouncedCallback(
    async () => {
      const baseUrl = `albait/export/task-report/?date=${moment(
        selectedDate,
      ).unix()}`;

      if (officesShortList && officesShortList.length > 0) {
        setAllReportLoading(true);
        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

        const promises = [];
        officesShortList.forEach(async (office, i) => {
          const promise = (async index => {
            await delay(300 * index);
            const url = `${baseUrl}&office=${office.id}`;
            await exportToExcel(url, `office${office.name}.xlsx`, false);
          })(i);

          promises.push(promise);
        });

        await Promise.all(promises);

        setAllReportLoading(false);
      }
    },
    60000,
    { leading: true, trailing: false },
  );

  const getTasks = () => {
    const payload = {
      startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
      page: currentPageNumber,
      platform: 'web',
    };
    if (selectedOffice && selectedOffice.value) {
      payload.office_id = selectedOffice.value;
    }
    if (selectedMember && selectedMember.id) {
      payload.assignee_id = selectedMember.id;
    }
    if (searchTerm && searchTerm.trim()) {
      payload.task_name = searchTerm.toLowerCase().trim();
    }
    if (taskStatus && taskStatus.value && taskStatus.value !== 'all') {
      payload.status = taskStatus.value;
    }
    // Remove null or undefined properties
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v != null),
    );

    console.log(2);
    filteredPayload;
    getTasksList(filteredPayload);
  };
  useEffect(() => {
    getTasks();
  }, [
    currentPageNumber,
    selectedDate,
    selectedOffice,
    selectedMember,
    // searchTerm,
    search,
    taskStatus,
  ]);
  const statusOptions = TaskStatusOptions?.map(option => ({
    ...option,
    label: t(option.key),
  }));
  useEffect(() => {
    statusFromParams
      ? statusOptions.map(statusOption => {
        if (statusOption.key === statusFromParams) {
          setTaskStatus(statusOption);
        }
      })
      : setTaskStatus({
        label: t('all_status'),
        value: null,
      });
  }, []);
  useEffect(() => {
    if (zoneFromParams && officesShortList?.length > 0) {
      officesShortList.map(office => {
        if (office.name === zoneFromParams) {
          setSelectedOffice({
            label: office.name,
            value: office.id,
          });
        }
      });
      setZoneFromParams(null);
    } else if (!selectedOffice) {
        setSelectedOffice({
          label: t('all_offices'),
          value: null,
        });
    }
  }, [officesShortList, zoneFromParams]);


  // Auto-select office for GM users
  useEffect(() => {
    console.log('Auto-selecting office for GM users if not already selected',localStorage.getItem('user_role'));
    if (
      localStorage.getItem('user_role') === 'gm' &&
      officesShortList &&
      officesShortList.length > 0 &&
      (!selectedOffice || !selectedOffice.value)
    ) {
      const firstOffice = officesShortList[0];
      setSelectedOffice({
          label: firstOffice.name,
          value: firstOffice.id,
        });
    }
  }, [officesShortList, selectedOffice]);
  return (
    <div className="content">
      <DeleteTaskModal
        isOpen={isOpen}
        toggle={() => toggleDeleteModal()}
        handleDelete={handleDeleteTask}
        isLoading={deleteIsLoading}
      />
      <CommonGrid alignItem="center">
        <PageTitle>{t('all_tasks')}</PageTitle>
        <CommonFlex gap="12px">
          {/* {localStorage.getItem('user_role') === 'admin' &&
          !localStorage.getItem('viewer_role') ? (
            <ColoredButton
              type="blue"
              onClick={() => handleExportAllOfficesReportToExcel()}
              padding={allReportLoading ? '0 45px' : '0 25px'}
            >
              {allReportLoading ? (
                <ButtonTextLoader color="#fff" loadingText=" " size={6} />
              ) : (
                <>{t('generate_all_report')}</>
              )}
            </ColoredButton>
          ) : null} */}
          {(localStorage.getItem('user_role') !== 'employee' ||
            localStorage.getItem('user_role') !== 'supervisor') ? (
            <WhiteButtonWithIcon
              onClick={() => handleSpecificOfficeExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={exportLoading ? '0 45px' : '0 25px'}
              disabled={!selectedOffice || !selectedOffice.value || exportLoading}
              style={(!selectedOffice || !selectedOffice.value || exportLoading) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            >
              {exportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
          {localStorage.getItem('user_role') !== 'employee' &&
            !localStorage.getItem('viewer_role') && (
              <ColoredButtonWithIcon
                onClick={() => history.push(`/user/create-task`)}
              >
                <ButtonIcon src={plusIcon} alt="" />
                {t('create_task')}
              </ColoredButtonWithIcon>
            )}
        </CommonFlex>
      </CommonGrid>
      <HeaderContainer columns="1fr">
        <TaskFilter
          getOrganizationMembersList={getOrganizationMembersList}
          organizationMembersList={orgMembersList}
          officesShortList={officesShortList}
          getOfficesShortList={getOfficesShortList}
          selectedOffice={selectedOffice}
          selectOffice={selectOffice}
          selectedMember={selectedMember}
          selectMember={selectMember}
          clearMember={clearMember}
          taskStatus={taskStatus}
          selectedDate={selectedDate}
          startDate={selectedDate.startDate}
          endDate={selectedDate.endDate}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          handleDateChange={handleDateChange}
          handleStatusChange={handleStatusChange}
          handleSearchByName={handleSearchByName}
          handleClearSearch={handleClearSearch}
        />
      </HeaderContainer>

      {totalTasksCount && totalTasksCount > 0 && pageSize ? (
        <TopPagination
          itemName={t('Tasks')}
          totalCount={totalTasksCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}

      <TasksList
        selectedOrganization={selectedOrganization}
        loadingTaskAssigneeId={loadingTaskAssigneeId}
        expandedTaskId={expandedTaskId}
        setExpandedTaskId={setExpandedTaskId}
        toggleDeleteModal={toggleDeleteModal}
        history={history}
        tasksList={tasksList}
        isLoading={isLoading}
        createTask={createTask}
      />

      {totalTasksCount && totalTasksCount > 0 && pageSize ? (
        <BottomPagination
          totalCount={totalTasksCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
    </div>
  );
};

export default Tasks;
